import { useEffect } from 'react';

import { useZodForm } from '../../../hooks/useZodForm.ts';
import { selectMarketAdjustments } from '../../../redux/features/selectors/orderSelectors.ts';
import { selectManualAdjustmentsForMarketAdjustmentsModalForm } from '../../../redux/features/selectors/selectManualAdjustmentsForMarketAdjustmentsModalForm.tsx';
import { useAppSelector } from '../../../redux/hooks.ts';
import { schMarketAdjustmentsModalForm } from '../types.ts';
import { stateToForm } from '../utils/stateToForm.ts';

export function useMarketAdjustmentsModalForm() {
  const manualAdjustments = useAppSelector(selectManualAdjustmentsForMarketAdjustmentsModalForm);
  const marketAdjustments = useAppSelector(selectMarketAdjustments);

  const form = useZodForm({
    schema: schMarketAdjustmentsModalForm,
    defaultValues: stateToForm({
      manualAdjustments,
      marketAdjustments,
    }),
    mode: 'onBlur',
  });

  useEffect(() => {
    form.reset(
      stateToForm({
        manualAdjustments,
        marketAdjustments,
      }),
    );
  }, [form, manualAdjustments, marketAdjustments]);

  return form;
}
